import { useField, connect } from 'formik';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faPlus } from '@fortawesome/free-solid-svg-icons';

import FieldContextFeeder from '../components/FieldContextFeeder';

/**
 * This component toggles another section visible, and also sets
 * the required field to match component state.
 *
 * TODO: Make more generic
 * TODO: Does jsdoc even work with these higher order component exports?
 */
const ToggleButtonField = ({ children, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const { value } = meta;
  const { setValue } = helpers;

  const toggleValue = () => setValue(value === 'NO' ? 'YES' : 'NO');

  return value === 'NO' ? (
    <OpenButton {...field} type="button" onClick={toggleValue}>
      <PlusIcon icon={faPlus} /> Lisää valinnat tukihenkilölle
    </OpenButton>
  ) : (
    <CloseWrapper>
      Tukihenkilön valinnat
      <CloseButton {...field} type="button" onClick={toggleValue}>
        <CloseIcon icon={faXmark} />
      </CloseButton>
    </CloseWrapper>
  );
};

const OpenButton = styled.button`
  background-color: transparent;

  border: solid 2px #163979;
  border-radius: 5px;

  padding: 8px 10px;

  align-self: center;

  font-size: 16px;
  font-weight: bold;
  color: #163979;

  cursor: pointer;
`;

const PlusIcon = styled(FontAwesomeIcon)`
  margin-right: 8px;
`;

const CloseWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  font-size: 16px;
  font-weight: bold;
  color: #163979;
`;

const CloseButton = styled.button`
  display: inline-block;
  width: fit-content;

  cursor: pointer;
`;

const CloseIcon = styled(FontAwesomeIcon)`
  width: 24px;
  height: 24px;

  color: #163979;
`;

const XIcon = styled(FontAwesomeIcon)``;

export default FieldContextFeeder(connect(ToggleButtonField));
